import { useMemo } from 'react';
import dayjs from 'dayjs';

export const useGetCalendarStartEndDate = (calendarDate: string) => {
  const [startDate, endDate] = useMemo(() => {
    if (!calendarDate) return ['', ''];
    const startDateInUTC = dayjs(String(calendarDate)).utc().toISOString();
    const endDateInUTC = dayjs(String(calendarDate)).add(1, 'day').add(-1, 's').utc().toISOString();

    return [startDateInUTC, endDateInUTC];
  }, [calendarDate]);

  return { startDate, endDate };
};
